









































































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import gql from 'graphql-tag'
import gqlFetchMore from '@/functions/gqlFetchMore'

const pageSize = 10
@Component({
  apollo: {
    transactions: {
      variables() {
        return {
          userUid: this.uid,
          order: this.order,
          first: pageSize,
          after: null,
        }
      },
      query() {
        return gql`
          query GET_TRANSACTIONS($userUid: String!, $order: String, $first: Int, $after: String) {
            transactions(userUid: $userUid, order: $order, first: $first, after: $after) {
              nextCursor
              data {
                uid
                amount
                meta
                createdAt
                createdBy {
                  uid
                  name
                  profileImageUrl
                }
                transactionable {
                  ...on Comment {
                    uid
                    createdBy {
                      uid
                      name
                      profileImageUrl
                    }
                    source {
                      domain
                      host
                    }
                  }
                  ...on User {
                    uid
                    name
                    profileImageUrl
                  }
                }

              }
            }
          }`
      },
    },
  },

})
export default class UserPageTransactions extends Vue {
  @Prop() uid!: string
  @Prop() user!: any
  transactions: any = null
  order: string = '-created_at'

  get canNext() {
    // `this.$apollo.queries.transactions.loading` because else possible to trigger twice (which gives duplicates)

    return !!(this.transactions && this.transactions.nextCursor && this.$apollo.queries.transactions && !this.$apollo.queries.transactions.loading)
  }

  next() { // @TODO see why gets called on tab change
    if (!this.$apollo.queries.transactions) return // @todo see why is there error without this line (when is `next` called?)
    gqlFetchMore(this, 'transactions', {
      userUid: this.uid,
      order: this.order,
      first: pageSize,
      after: this.transactions.nextCursor,
    })
  }

  created() {
    window.addEventListener('scroll', () => {
      if (!this.canNext) return
      if ((window.innerHeight + window.pageYOffset) >= document.body.offsetHeight) {
        this.next()
      }
    })
  }

  mounted() {
    this.$apollo.queries.transactions.refetch()
  }

}

